if (!customElements.get('filer-cart-offer')) {
  class FilerCartOffer extends HTMLElement {
    connectedCallback() {
      // Remember only the completed signup visit, never email or discount eligibility.
      const storageKey = 'filer_email_signup_completed';
      let submitted = false;
      try {
        if (this.dataset.success === 'true') sessionStorage.setItem(storageKey, '1');
        submitted = sessionStorage.getItem(storageKey) === '1';
      } catch (_) { /* The native form and server-rendered status still work without storage. */ }
      const showStatus = this.dataset.success === 'true' || this.dataset.subscribed === 'true' || this.dataset.applied === 'true' || (this.dataset.knownCustomer !== 'true' && submitted);
      const details = this.querySelector('details');
      const status = this.querySelector('.filer-cart-offer__status');
      if (details && status && showStatus && !this.querySelector('.filer-cart-offer__error')) {
        details.hidden = true;
        status.hidden = false;
      }
    }
  }
  customElements.define('filer-cart-offer', FilerCartOffer);
}
